import * as React from "react";
const SvgImport20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 19,
        height: 18,
        fill: "black",
        viewBox: "0 0 19 18"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M1 0H0v18h15v-6h-2v4H2V2h11v4h2V0H1Zm7.793 4.293.707-.707L10.914 5l-.707.707L7.914 8H19v2H7.914l2.293 2.293.707.707L9.5 14.414l-.707-.707-4-4L4.086 9l.707-.707 4-4Z",
      clipRule: "evenodd"
    })
  );
export default SvgImport20Px;
